"use client";
import React, { useState } from "react";
import { Dropdown } from "antd";
import { useSharedData } from "bossjob-remote/dist/hooks";
import styles from "./JobHeader.pc.module.scss";
import classNames from "classnames";
import { DropDownIcon, ExchangeIcon } from "./Icons";

export const MoneyExchange = ({ data, handleClick }) => {
  const langDic = useSharedData("DICTIONARY") || {};
  const [value, setValue] = useState(data.text);
  const [open, setOpen] = useState(false);

  const option = data?.exchange?.map((v) => {
    return {
      label: (
        <div
          data-checked={value === v.text}
          className={styles.exchangeMoneyListWrapper}
          onClick={() => {
            setValue(v.text);
            handleClick(v.text);
          }}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: 400,
              margin: 0
            }}
          >
            <span
              className={classNames({
                [styles.circle]: true,
                [styles.checked]: value === v.text
              })}
            >
              <svg
                width='12'
                height='9'
                viewBox='0 0 12 9'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  id='Vector 4226'
                  d='M1.42188 3.23438L4.98438 6.79688L10.5781 1.20312'
                  stroke='white'
                  strokeWidth='2'
                />
              </svg>
            </span>
            <img src={v.currency_icon} width={24} height={24} style={{ marginRight: 6 }} />{" "}
            {v.currency_code}
          </span>
          <span className={styles.listSalary}>{v.text}</span>
        </div>
      ),
      key: v?.id
    };
  });

  const convertTo = langDic?.moneyExchange?.convertTo;

  if (data.is_show_exchange) {
    return (
      <div className={styles.exchangeBtn}>
        <Dropdown
          menu={{ items: option }}
          placement='bottomLeft'
          overlayStyle={{ maxHeight: 280 }}
          onOpenChange={setOpen}
          getPopupContainer={(node) => node.parentElement}
          dropdownRender={(originalNode) => {
            return (
              <div className={styles.moneyDropdownWrapper}>
                <div className={styles.header}>
                  {convertTo}
                  {/* Convert to */}
                </div>
                {originalNode}
              </div>
            );
          }}
        >
          <div className={styles.exchangeIconDownWrapperOnRemoteJob} data-hover={open}>
            <ExchangeIcon />
            <DropDownIcon />
          </div>
        </Dropdown>
      </div>
    );
  }
  return null;
};

export default MoneyExchange;
